import http from './http';

/// Tahsilat
export function getBugunTahsilat() {
    return http.get(`/tahsilat/bugun`);
}

export function getDunTahsilat() {
    return http.get(`/tahsilat/dun`);
}

export function getBuayTahsilat() {
    return http.get(`/tahsilat/buay`);
}

export function getGecenayTahsilat() {
    return http.get(`/tahsilat/gecenay`);
}

export function getMakinaSayisi() {
    return http.get(`/tahsilat/makinasayisi`);
}

